import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Card, CardBody, Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"
import { withRouter } from "react-router"
import AddGrade from "./AddDemandeStage"
import DataTableGrade from "./DataTableDemandeStage"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import AddDemandeStage from "./AddDemandeStage";
import DataTableDemandeStage from "./DataTableDemandeStage";

const DemandeStage = props => {
  const [section, setSection] = useState(1)

  const back = () => {
    setSection(1)
  }
  var userAuthEtudiant = JSON.parse(localStorage.getItem("userAuthEtudiant"))
  var niveau_id = userAuthEtudiant.user.niveau_id
  var cycle_id = userAuthEtudiant.user.cycle_id
  const renderBlock = section => {
    if (section === 1) {
      return <DataTableDemandeStage />
    } else if (section === 2) {
      return <AddDemandeStage setSection={setSection} back={back} />
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{props.t("Demande de stage")} | Cresus </title>
        </MetaTags>
        <Container fluid>
          <div>
            <Nav tabs>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 1,
                  })}
                  onClick={() => {
                    setSection(1)
                  }}
                >
                  {cycle_id == 2 && niveau_id == 2 ? (("Demande mastère")) : (("Demande PFE"))}

                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 2,
                  })}
                  onClick={() => {
                    setSection(2)
                  }}
                >
                  {cycle_id == 2 && niveau_id == 2 ? (("Ajouter Demande mastère")) : (("Ajouter Demande PFE"))}

                </NavLink>
              </NavItem>
            </Nav>
            <Card>
              <CardBody>{renderBlock(section)}</CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(DemandeStage))
DemandeStage.propTypes = {
  t: PropTypes.any,
}
